import { render, staticRenderFns } from "./IbxSettings.vue?vue&type=template&id=f93b3a8e"
import script from "./IbxSettings.vue?vue&type=script&lang=js"
export * from "./IbxSettings.vue?vue&type=script&lang=js"
import style0 from "./IbxSettings.vue?vue&type=style&index=0&id=f93b3a8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports